export const formatName = (str) => {
  if (!str) return "N/A"; // Add a check for null or undefined values
  return str
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/-/g, " ") // Replace hyphens with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
};
